export default __webpack_public_path__ + "1283886c8798d0bd37b547ca2f41d474.png";